import { useEffect, useState } from "react";
import { api_private_get, api_private_post, showAlert } from "script";

function DepositMethod({ method }) {
  return (
    <div className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3 col-xxl-2">
      <div
        id={`deposit-select-${method}`}
        className="pay_method__paymethod-item pay-methods p-2 rounded-3 cpoint"
      >
        <img
          src={`/assets/images/payments/${method}.png`}
          alt={method}
          className="rounded"
        />
      </div>
    </div>
  );
}

export default function DepositTabCad() {
  const [accountInfo, setAccountInfo] = useState(null);
  const [interacEmail, setInteracEmail] = useState("");
  const [reference, setReference] = useState("");

  useEffect(() => {
    api_private_get("/account/get_info", (data) => {
      setAccountInfo(data);
    });
    api_private_post("/wallet/get_interac_deposit_info", {}, (data) => {
      if (data?.error) {
        showAlert(data.error, "danger");
        return;
      }
      setInteracEmail(data.interac_email || "");
      setReference(data.reference || "");
    });
  }, []);

  const copyToClipboard = (value, label) => {
    if (!value) return;
    if (!navigator.clipboard) {
      showAlert("Clipboard not available.", "danger");
      return;
    }
    navigator.clipboard
      .writeText(value)
      .then(() => {
        showAlert(`${label} copied to clipboard!`, "success");
      })
      .catch((err) => {
        showAlert("Failed to copy! " + err, "danger");
      });
  };

  return (
    <div id="deposit-tab">
      <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8 mb-8 mb-md-10">
        <div className="pay_method__paymethod-title d-flex align-items-center gap-3 mb-6 mb-md-8">
          <i className="ti ti-credit-card fs-four g1-color"></i>
          <h5 className="n10-color">Payment methods</h5>
        </div>
        <div className="pay_method__paymethod-alitem">
          <div className="row gx-4 gy-4">
            <DepositMethod method="interac" />
          </div>
        </div>
      </div>

      <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8">
        <div className="pay_method__paymethod-title mb-5 mb-md-6">
          <h5 className="n10-color">Deposit by Interac e-Transfer</h5>
          <p className="fs-seven n4-color mt-2">
            Send an Interac e-Transfer in CAD to the address below. Funds are
            credited to your account manually and may take a short while to
            appear.
          </p>
        </div>

        <div className="pay_method__amount d-flex align-content-center justify-content-between py-3 px-5 px-md-6 mb-6 flex-wrap gap-3">
          <div className="pay_method__amount-actual">
            <span className="fs-seven mb-3">Send Interac e-Transfer to</span>
            <div className="d-flex align-items-center gap-3">
              <span className="fw-bold" id="deposit-interac-email">
                {interacEmail || "—"}
              </span>
              <i
                className="ti ti-copy fs-seven cpoint"
                id="deposit-copy-email-btn"
                onClick={() =>
                  copyToClipboard(interacEmail, "Interac deposit email")
                }
              ></i>
            </div>
          </div>
        </div>

        <div className="pay_method__amount d-flex align-content-center justify-content-between py-3 px-5 px-md-6 mb-6 mb-md-8 flex-wrap gap-3">
          <div className="pay_method__amount-actual">
            <span className="fs-seven mb-3">Reference message (required)</span>
            <div className="d-flex align-items-center gap-3">
              <span
                className="fw-bold"
                id="deposit-reference"
                style={{ fontFamily: "monospace" }}
              >
                {reference || "—"}
              </span>
              <i
                className="ti ti-copy fs-seven cpoint"
                id="deposit-copy-reference-btn"
                onClick={() => copyToClipboard(reference, "Reference message")}
              ></i>
            </div>
          </div>
        </div>

        <div className="pay_method__paymethod-title mb-4">
          <h6 className="n10-color">Important</h6>
          <p className="fs-seven n4-color mt-2">
            You must set the Interac e-Transfer{" "}
            <strong>message / reference</strong> to your account id above so we
            can match the deposit to your account.
          </p>
          <p className="fs-seven n4-color mt-2">
            The full name and email address on your Interac e-Transfer must
            match the details registered on your account exactly, or the deposit
            cannot be processed.
          </p>
        </div>

        <div className="row gx-4 gy-4">
          <div className="col-12 col-md-6">
            <label className="mb-3">Your registered full name</label>
            <input
              className="n11-bg rounded-8"
              type="text"
              readOnly
              value={accountInfo?.display_name || ""}
            />
          </div>
          <div className="col-12 col-md-6">
            <label className="mb-3">Your registered email</label>
            <input
              className="n11-bg rounded-8"
              type="text"
              readOnly
              value={accountInfo?.email || ""}
            />
          </div>
        </div>

        <p className="fs-seven n4-color mt-5">
          If you have any questions or concerns, please{" "}
          <a className="g1-color" href="support.html">
            contact us
          </a>
          .
        </p>
      </div>
    </div>
  );
}
